import { render, staticRenderFns } from "./LabAnalysisOfIron.vue?vue&type=template&id=5bca594b&"
import script from "./LabAnalysisOfIron.vue?vue&type=script&lang=ts&"
export * from "./LabAnalysisOfIron.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports